import { ClienteF } from '../util/ClienteFormarte';

const apiUrl = process.env.URL_API || "http://localhost:8080";

const getClientela = async (cpf) => {
    try {
        const response = await fetch(`${apiUrl}/clinica-integrada/clientela/cpf?cpf=${cpf}`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            }
        });

        // Verifica se a resposta HTTP foi bem-sucedida
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`HTTP error! Status: ${response.status}. Message: ${errorText}`);
        }
        const authHeader = response.headers.get('Authorization');
        const token = authHeader ? authHeader.replace('Bearer ', '') : null;
        if (token) {
            // Armazena o token JWT no localStorage
            localStorage.setItem('jwtToken', token);
        }

        // Obtém o corpo da resposta JSON
        const clientelaData = await response.json();

        // Verifica se a resposta é um objeto (cliente encontrado) ou uma string (erro)
        if (typeof clientelaData !== 'string') {
            let Icliente = {
                nome: ClienteF.getFirstAndLastName(clientelaData.nomeCliente),
                matricula: (clientelaData.matricula.cduop).toString().padStart(4, "0") + "-" + (clientelaData.matricula.sqmatric).toString().padStart(6, "0") + "-" + clientelaData.matricula.nudv,
                categoria: ClienteF.formataCategoria(clientelaData.categoria.tipoCategoria),
                dataNascimento: ClienteF.formataData(clientelaData.dataNascimento),
                dataVencimento: ClienteF.formataData(clientelaData.dataVencimento),
                idCategoria: clientelaData.categoria.tipoCategoria,
                cpf: clientelaData.cpf
            };
            return Icliente;
        } else {
            return clientelaData; // Retorna a mensagem de erro caso a resposta seja uma string
        }
    } catch (error) {
        return `Erro ao buscar Cliente: ${error.message}`;
    }
}


export const ApiClientela = {
    getClientela
};
